import { render } from "./DrawerFichaProfesional.vue?vue&type=template&id=4e9f797a&ts=true"
import script from "./DrawerFichaProfesional.vue?vue&type=script&lang=ts"
export * from "./DrawerFichaProfesional.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__